<template>
    <div id="app">
        <client-only>
            <LoadingBar />
        </client-only>
        <div class="content">
            <client-only>
                <Header />
            </client-only>
            <div class="sub-header" v-if="showCrumbs">
                <div class="container">
                    <breadcrumbs />
                </div>
            </div>
            <nuxt />
            <client-only>
                <FooterInner />
                <NotifyModal />
                <SubscribePopup2 />
                <CookiesModal />
                <!--            <CountryModal/>-->
            </client-only>
        </div>
    </div>
</template>
<script>
import LoadingBar from "@/components/LoadingBar";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import Header from "@/components/Header.vue";
import FooterInner from "@/components/FooterInner.vue";
import NotifyModal from "@/components/NotifyModal.vue";
import SubscribePopup2 from "@/components/ui/SubscribePopup2.vue";
import CookiesModal from "@/components/ui/CookiesModal.vue";
// import CountryModal from "@/components/CountryModal.vue";
export default {
    name: "App",
    components: {
        SubscribePopup2,
        LoadingBar,
        Breadcrumbs,
        Header,
        FooterInner,
        NotifyModal,
        CookiesModal,
        // CountryModal
    },
    data() {
        return {
            isMac: false,
        };
    },
    computed: {
        bodyClass() {
            let bodyClass = this.$device.isDesktop ? "is_desktop" : "is_mobile";
            bodyClass += this.isMac ? " is_apple" : "";
            bodyClass += " page-" + this.$route.name;
            bodyClass += this.showCrumbs ? "" : " no-subheader";

            return bodyClass;
        },
        showCrumbs() {
            return this.$device.isDesktop && this.$route.name !== "index";
        },
    },
    watch: {
        $device() {
            if (this.$device.isIos || this.$device.isMacOS) this.isMac = true;
        },
    },
    head() {
        return {
            meta: [{ rel: "canonical", href: "https://post-post-scriptum.com" + this.$route.path }],
            bodyAttrs: {
                class: this.bodyClass,
            },
        };
    },
    mounted() {
        this.isMac = this.$device.isIos || this.$device.isMacOS;

        if (this.$device.isDesktop) {
            document.querySelector("body").style.setProperty("--footer-height", 0 + "px");
        }
    },
};
</script>
